module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_instagram_color-756615696300e514010755431de07a28.svg";